import revive_payload_client_4sVQNw7RlN from "/home/colin/cw-stage/cancer-not-cancer/client/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/colin/cw-stage/cancer-not-cancer/client/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/colin/cw-stage/cancer-not-cancer/client/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/home/colin/cw-stage/cancer-not-cancer/client/node_modules/nuxt/dist/app/plugins/payload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/colin/cw-stage/cancer-not-cancer/client/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import plugin_vue3_A0OWXRrUgq from "/home/colin/cw-stage/cancer-not-cancer/client/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/home/colin/cw-stage/cancer-not-cancer/client/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/colin/cw-stage/cancer-not-cancer/client/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import chunk_reload_client_UciE0i6zes from "/home/colin/cw-stage/cancer-not-cancer/client/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import draggable_EKFVpjGqMx from "/home/colin/cw-stage/cancer-not-cancer/client/plugins/draggable.js";
import error_handler_VFH3VvK7yG from "/home/colin/cw-stage/cancer-not-cancer/client/plugins/error-handler.js";
import fontawesome_klhsrycjcK from "/home/colin/cw-stage/cancer-not-cancer/client/plugins/fontawesome.js";
import run_vm_client_wuShump7gh from "/home/colin/cw-stage/cancer-not-cancer/client/plugins/run-vm.client.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  check_outdated_build_client_8vK7RkfGxZ,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  chunk_reload_client_UciE0i6zes,
  draggable_EKFVpjGqMx,
  error_handler_VFH3VvK7yG,
  fontawesome_klhsrycjcK,
  run_vm_client_wuShump7gh
]